import { Component, OnInit, Input } from '@angular/core'

import { CredentialItem } from '../models/credential-item'
import { EligibilityStatusTag } from '../../models'

@Component({
  standalone: false,
  selector: 'app-verify-credential-item',
  templateUrl: './credential-item.component.html',
  styleUrls: ['./credential-item.component.scss']
})
export class CredentialItemComponent implements OnInit {

  @Input() public credentialItem: CredentialItem
  @Input() public expanded: boolean

  public eligibilityStatusTag: EligibilityStatusTag
  public name: string
  public validityLabel: string

  public ngOnInit(): void {
    const { eligibilityStatusTag, rule, validityLabel } = this.credentialItem
    this.name = rule.display_name
    this.eligibilityStatusTag = eligibilityStatusTag
    this.validityLabel = validityLabel
  }

}
